module.exports = __webpack_public_path__ + "static/media/hmm-logo-shadow.c26ce3bb.png";